<template>
  <collapsible-widget
    title="INFRASTRUKTURA TELEKOMUNIKACYJNA"
    :maxHeight="30"
    :expand-widget="systemLayersExpanded"
    :accordion="accordion"
    @toggled="onToggled"
    ref="collapsible"
    :default-expanded="systemLayersExpanded"
    :selectAllEnabled="systemLayersHasItems"
    :onCheckboxChanged="onCheckboxChanged"
    :allSelected.sync="allSelected"
    :indeterminate="indeterminate">
    <composition-layers :layers="systemLayers" @set-layer-extent="setLayerExtent"></composition-layers>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from "vuex";
import CollapsibleWidget from "./CollapsibleWidget";
import CompositionLayers from "./CompositionLayers";
import { SYSTEM_LAYERS_EXPANDED_SET, SET_LAYER_VISIBILITY } from "../store/mutations.type";

export default {
  name: "Compositions",
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers
  },
  computed: {
    ...mapGetters(["readOnly", "systemLayersExpanded"]),
    systemLayers() {
      return Array(...this.$store.getters.systemLayers.sort((a, b) => { return b.order - a.order; }));
    },
    systemLayersHasItems() {
      return this.systemLayers.length > 0;
    },
    indeterminate() {
      return this.systemLayers.some(l => l.visible) && this.systemLayers.some(l => !l.visible);
    },
    allSelected() {
      return this.systemLayers.every(l => l.visible);
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit("toggled", expanded);
      this.$store.commit(SYSTEM_LAYERS_EXPANDED_SET, (expanded || {}).expanded);
    },
    onCheckboxChanged(value) {
      if (value) {
        this.systemLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: true });
        });
      } else {
        this.systemLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: false });
        });
      }
    },
    setLayerExtent(extent) {
      this.$emit("set-layer-extent", extent);
    }
  }
};
</script>
